import { useTranslations } from '@npco/common-utils-translations'
import { Flex, Message, MessageSize, SvgIcon } from '@npco/zeller-design-system'

import { ReactComponent as SuccessThumbsUpIcon } from 'assets/svg/success-thumbs-up.svg'
import { useIsMobileResolution } from 'hooks/useIsMobileResolution'
import { useTransferState } from 'pages/Transfer/Transfer.context'
import { TransferEvent } from 'pages/Transfer/Transfer.stateMachine'
import { translations } from 'pages/Transfer/TransferFields/MFATransfer/MFATransfer.i18n'

interface MFASuccessProps {
  handleNewTransfer: () => void
}

export const MFASuccess = ({ handleNewTransfer }: MFASuccessProps) => {
  const {
    transferState: [, send],
  } = useTransferState()
  const isMobile = useIsMobileResolution()
  const t = useTranslations(translations)

  const iconSize = isMobile ? '140' : '180'

  return (
    <Flex width="100%" pt="10%" justifyContent="center">
      <Message
        align="center"
        title={t('mfaSuccessTitle')}
        description={t('mfaSuccessDescription')}
        size={MessageSize.MEDIUM}
        primaryButton={{
          label: t('mfaSuccessPrimaryButtonLabel'),
          onClick: handleNewTransfer,
        }}
        secondaryButton={{
          label: t('mfaSuccessSecondaryButtonLabel'),
          onClick: () => send(TransferEvent.Back),
        }}
        image={
          <SvgIcon width={iconSize} height={iconSize}>
            <SuccessThumbsUpIcon />
          </SvgIcon>
        }
      />
    </Flex>
  )
}
